import { Injectable } from '@angular/core'
import { Observable, catchError } from 'rxjs'
const httpOptions3 = {
  responseType: 'arraybuffer' as 'json',
  'Content-Type': 'application/json',
}
import { HttpClient } from '@angular/common/http'
@Injectable({
  providedIn: 'root',
})
export class FileServices {
  constructor(private _http: HttpClient) {}
  CreateDirectoryDoesNotExists(
    p: any,
    outputClientId: any,
    blotterId,
  ): Observable<any> {
    return this._http
      .get<any>(
        '/FileManagerCredentials/create?repid=' +
          p +
          '&clientid=' +
          outputClientId +
          '&blotterid=' +
          blotterId,
      )
      .pipe(catchError(this.handleError))
  }
  downloads(f: any): Observable<any> {
    return this._http
      .post<any>(`/api/Download/DownloadF`, f, httpOptions3)
      .pipe(catchError(this.handleError))
  }
  checkfile(blotterId: any, uploadedFiles: string[] = []): Observable<object> {
    const params = {
      blotterId: blotterId,
      uploadedFiles: uploadedFiles,
    }
    return this._http
      .post<object>('/api/Transactions/CheckingFile', params)
      .pipe(catchError(this.handleError))
  }
  private handleError(error: Response | any) {
    let errMsg: string
    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body || JSON.stringify(body)
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`
    } else {
      errMsg = error.message ? error.message : error.toString()
    }
    return Promise.reject(errMsg)
  }
}
